import { useState } from 'react'

//Components
import SelectAddress from 'pages/dashboard/e-reporting/forms/components/reuseables/select-address/SelectAddress'

//Hoc
import withFetch from './withFetch'

//Context
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function PilihAreaPembeliProperti({ data }) {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { disabledAll, form, isAprroval, isEditing, isRent } = useFormState()

  const [selectedData, setSelectedData] = useState({
    ...form.area_pembeli_properti.value,
    value: form.area_pembeli_properti.value.id,
    label: form.area_pembeli_properti.value.name
  })

  const onNext = () => {
    handlePrevState()
    formHandler('area_pembeli_properti', selectedData)
    setCurrentStep(STEPS.alamatPembeliProperti)
  }
  return (
    <SelectAddress
      order="a. "
      question={`Di area mana domisili ${isRent ? "penyewa" : "pembeli"}?`}
      placeholder="Tulis area"
      required
      data={data}
      selectedData={selectedData}
      setSelectedData={setSelectedData}
      onNext={onNext}
      showButton={true}
      disabled={disabledAll}
    />
  )
}

export default withFetch(PilihAreaPembeliProperti)